(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/org/org.tpl.html', [
'<section class="org">',
'',
'  <h4>',
'    <a ng-link="orgs({\'org\': \'all\'})" translate>org.orglist</a>',
'    <span>/</span>',
'    {{::org.org.name}}',
'  </h4>',
'',
'  <hr>',
'',
'  <div class="col-md-2">',
'    <ul class="nav nav-pills nav-stacked">',
'      <li ng-repeat="tab in org.tabs" ng-class="{active: org.tab==tab}">',
'        <a ng-link="org({org: org.org.id, tab: tab})">{{ \'tab.\' + tab | translate}}</a>',
'      </li>',
'    </ul>',
'  </div>',
'',
'  <div class="col-md-10">',
'',
'    <div class="panel panel-default" ng-class="{\'panel-danger\': org.org.pending}">',
'',
'      <div class="panel-heading text-center" ng-if="org.tab==\'infos\' && org.delegations.length > 0 && profile === \'SUPERUSER\'">',
'        <span translate>org.ohasdeleg</span>',
'        <span ng-repeat="delegation in org.delegations">',
'          <a ng-link="user({id: delegation.uid, tab: \'delegations\'})">{{ org.usersNames[delegation.uid] ? org.usersNames[delegation.uid] : delegation.uid }}</a>{{$last ? \'\' : \', \'}}',
'        </span>',
'      </div>',
'',
'      <div class="panel-heading text-center" ng-if="org.org.pending">',
'        <span translate>org.pendingmsg</span>',
'        <button class="btn btn-default" ng-click="org.confirm()" translate>org.confirm</button>',
'      </div>',
'',
'      <div class="panel-body" ng-if="org.tab==\'infos\'">',
'        <div ng-inline="templates/orgForm.tpl.html"',
'          ng-init="model=org.org;promise=org.org.$promise;required=org.required;orgTypeValues=org.orgTypeValues"></div>',
'        <hr>',
'        <div class="pull-right">',
'          <button ng-click="org.save()" class="btn btn-primary" translate ng-disabled="orgForm.$invalid">org.save</button>',
'        </div>',
'      </div>',
'',
'      <div class="panel-body" ng-if="org.tab==\'area\'">',
'        <areas item="org.org"></areas>',
'      </div>',
'',
'      <div class="panel-body" ng-if="org.tab==\'users\'">',
'        <input type="text" class="filter-table form-control pull-right ng-pristine ng-untouched ng-valid ng-empty" ng-model="org.q" placeholder="{{\'role.filter_users\' | translate}}"></input>',
'        <i class="glyphicon glyphicon-remove-sign panel-filter-table-reset" ng-show="org.q != \'\'" ng-click="org.q = \'\'"></i>        ',
'        <h3 class="roles-title">',
'          <ng-pluralize count="org.users.length"',
'                        when="{\'0\': \'{{ &quot;role.users_none&quot; | translate }}\',',
'                               \'1\': \'{} {{ &quot;role.user&quot; | translate }}\',',
'                               \'other\': \'{} {{ &quot;role.users&quot; | translate }}\'}">',
'        </h3>',
'        <form class="form-inline">',
'          <div class="form-group">',
'            <label for="orguser" translate>org.userlabel</label>',
'            <select class="pull-right form-control input-sm" ng-model="org.user"',
'               id="orguser" ng-change="org.associate()"',
'               data-placeholder-text-single="\'...\'"',
'               ng-options="u.uid as (u.sn + \' \' + u.givenName) for u in org.notUsers" chosen>',
'            </select>',
'          </div>',
'        </form>',
'',
'        <table class="table table-striped table-condensed">',
'',
'          <thead>',
'            <tr>',
'              <th translate>users.user</th>',
'              <th translate>user.action</th>',
'            </tr>',
'          </thead>',
'',
'          <tbody>',
'            <tr dir-paginate="user in org.users | filter: org.q | itemsPerPage: org.itemsPerPage | orderBy : \'sn\'">',
'              <td>',
'                <a ng-link="user({id: user.uid, tab: \'infos\'})">{{::user.sn}} {{::user.givenName}}</a>',
'              </td>',
'              <td>',
'                <a href="javascript:void(0)" ng-click="org.associate(user.uid, true)" class="text-danger" title="{{org.i18n.remove}}">',
'                  <i class="glyphicon glyphicon-remove"></i>',
'                </a>',
'              </td>',
'            </tr>',
'          </tbody>',
'',
'        </table>',
'',
'        <dir-pagination-controls></dir-pagination-controls>',
'',
'      </div>',
'',
'      <div class="panel-body" ng-if="org.tab==\'manage\'">',
'        <div class="alert alert-danger clearfix">',
'          <i class="glyphicon glyphicon-exclamation-sign"></i>',
'          <span translate>org.warning</span>',
'          <button ng-confirm-click="{{ \'org.delete\' | translate}} ?" confirmed-click="org.delete()" class="btn btn-danger" translate>org.delete</button>',
'        </div>',
'      </div>',
'',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();